// 환경변수 기반 feature flag.
// 'true' 문자열일 때만 활성, 미설정/기타 값은 false.
const flag = (v) => String(v).toLowerCase() === 'true';

export const COMMERCE_ENABLED = flag(import.meta.env.VITE_FEATURE_COMMERCE);
export const REFERRAL_ENABLED = flag(import.meta.env.VITE_FEATURE_REFERRAL);
